import { Component } from 'react';

import BpkGridToggle from '@skyscanner-internal/backpack-web/bpk-component-grid-toggle';
import {
  BpkBox,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkRtlToggle from '@skyscanner-internal/backpack-web/bpk-component-rtl-toggle';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';
import { GLOBAL } from 'saddlebag-browser';

import { logExperimentChokepoint } from '../../../logMiniEvent';
import withErrorBoundary from '../../ErrorBoundary';
import BrowseList from '../BrowseList';
import { DEFAULT_STRINGS } from '../constants';
import StringsContext from '../contexts/StringsContext';

import type { DestinationsExplorerProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './DestinationsExplorer.module.scss';

class DestinationsExplorer extends Component<DestinationsExplorerProps> {
  componentDidMount() {
    if (window.performance && window.performance.mark) {
      window.performance.mark('destinations-explorer_ready');
    }
    const $window = GLOBAL.getWindow();
    // eslint-disable-next-line no-underscore-dangle
    if ($window?.__internal?.pageType === 'flights-from-city-airport') {
      logExperimentChokepoint('users_who_saw_destination_images_with_coverage');
    }
  }

  render() {
    const {
      debug = false,
      destination,
      destinations,
      enableLazyLoading = true,
      numberOfDestinations,
      origin,
      shouldNotRedirectToExplore,
      strings = DEFAULT_STRINGS,
      subTitle,
      title,
    } = this.props;
    return (
      destinations.length > 0 && (
        <BpkBox id="destinations-explorer">
          {debug && (
            // BpkVessel (not BpkBox/BpkFlex): DestinationsExplorer.module.scss's
            // `&__toggles` rule carries `float: right` and `direction: ltr`.
            // Neither BpkBox nor BpkFlex exposes a `float` prop (not in the
            // shared/BpkBox/BpkFlex prop tables), so this cannot be expressed via
            // a Backpack layout prop. See
            // backpack-api-gaps/WOM-6799-destinationsexplorer-shell.md.
            <BpkVessel className={STYLES.DestinationsExplorer__toggles}>
              <BpkGridToggle /> | <BpkRtlToggle />
            </BpkVessel>
          )}
          <BpkBox>
            {title && (
              // BpkVessel (not BpkBox): DestinationsExplorer.module.scss's `&__header`
              // rule is `margin-bottom: tokens.$bpk-one-pixel-rem * 12` (12px / 0.75rem),
              // which has no exact BpkSpacing token match (SM=4px, Base=16px), and
              // BpkSectionHeader has no spacing prop. See
              // backpack-api-gaps/WOM-6799-destinationsexplorer-shell.md.
              <BpkVessel className={STYLES.DestinationsExplorer__header}>
                <BpkSectionHeader title={title} description={subTitle} />
              </BpkVessel>
            )}
            <StringsContext.Provider value={strings}>
              <BrowseList
                destinations={destinations}
                enableLazyLoading={enableLazyLoading}
                shouldNotRedirectToExplore={shouldNotRedirectToExplore}
                numberOfDestinations={numberOfDestinations}
                query={{ origin, destination }}
              />
            </StringsContext.Provider>
          </BpkBox>
        </BpkBox>
      )
    );
  }
}

const DestinationsExplorertWithErrorBoundary = withErrorBoundary(
  DestinationsExplorer,
  'destinations-explorer-component',
);

export default DestinationsExplorertWithErrorBoundary;
